import { render, staticRenderFns } from "./DatasetsView.vue?vue&type=template&id=cda7546e&scoped=true"
import script from "./DatasetsView.vue?vue&type=script&lang=js"
export * from "./DatasetsView.vue?vue&type=script&lang=js"
import style0 from "./DatasetsView.vue?vue&type=style&index=0&id=cda7546e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda7546e",
  null
  
)

export default component.exports